import { useState } from 'react';

/**
 * Stores boolean value and the method to toggle it.
 * @return {Array} with the value and the toggle method.
 */
export default function useToggle(initialValue = true) {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    toggle: () => setValue(!value),
    setTrue: () => setValue(true),
    setFalse: () => setValue(false),
  };
}
